export const defaultNfseNatureState = () => ({
  id: null,
  code: null,
  description: '',
});

const defaultNfseNaturesModuleState = () => ({
  summaryNfseNatures: [],
  paginationNfseNatures: {
    perPage: 15,
    currentPage: 1,
  },
});

const initialState = {
  ...defaultNfseNaturesModuleState(),
  nfseWarnings: [],
  nfseNature: {
    ...defaultNfseNatureState(),
  },
};

export default {
  ...initialState,
};
